export default __webpack_public_path__ + "images/9T.27b6cba.png";